export default __webpack_public_path__ + "static/media/Storm_Black.e4b130c2.webp";